<script lang="ts">
  import { api } from '../../lib/api';
  import type { Role, UserRecord } from '../../../../shared/src/types';
  import type { Overview } from './types';

  let { data, reload }: { data: Overview; reload: () => void } = $props();
  let draft = $state<{ id?: string; username: string; displayName: string; role: Role; password: string } | null>(null);
  let error = $state<string | null>(null);

  function edit(u: UserRecord | null) {
    error = null;
    draft = u ? { id: u.id, username: u.username, displayName: u.displayName, role: u.role, password: '' } : { username: '', displayName: '', role: 'operator', password: '' };
  }
  async function save() {
    if (!draft) return;
    try {
      await api.post('/api/admin/users', { ...draft, password: draft.password || undefined });
      draft = null;
      reload();
    } catch (err) {
      error = (err as Error).message;
    }
  }
  async function remove(u: UserRecord) {
    if (!confirm(`Delete user ${u.username}?`)) return;
    try {
      await api.del(`/api/admin/users/${u.id}`);
      reload();
    } catch (err) {
      error = (err as Error).message;
    }
  }
</script>

<div class="panel">
  <div class="row"><h3 class="grow">Users</h3><button class="primary" onclick={() => edit(null)}>Add user</button></div>
  <p class="muted">admin: everything · director: director panel, talk to anyone, mock tally · operator: camera view, party line, call · viewer: listen only</p>
  {#each data.users as u (u.id)}
    <div class="list-item">
      <b class="grow">{u.displayName} <span class="muted">({u.username})</span></b>
      <span class="badge">{u.role}</span>
      <button class="small" onclick={() => edit(u)}>Edit</button>
      <button class="small danger" onclick={() => remove(u)}>Delete</button>
    </div>
  {/each}
  {#if error && !draft}<p class="error">{error}</p>{/if}
</div>

{#if draft}
  <div class="panel" style="margin-top:12px">
    <div class="form">
      <label>Username <input bind:value={draft.username} autocapitalize="off" /></label>
      <label>Display name <input bind:value={draft.displayName} /></label>
      <label>Role
        <select bind:value={draft.role}><option>admin</option><option>director</option><option>operator</option><option>viewer</option></select>
      </label>
      <label>{draft.id ? 'New password (blank = keep)' : 'Password'} <input type="password" autocomplete="new-password" bind:value={draft.password} /></label>
    </div>
    {#if error}<p class="error">{error}</p>{/if}
    <div class="row" style="margin-top:12px"><button class="primary" onclick={save}>Save</button><button onclick={() => (draft = null)}>Cancel</button></div>
  </div>
{/if}
